module.exports = __webpack_public_path__ + "static/DOI-2x-caae20157954096e0e74b05e5f2c7d34.png";